module.exports = __webpack_public_path__ + "static/media/filter.108b48ff.svg";